import { c as _c } from "react/compiler-runtime";
/** Radius the cap cells pass to their donut, so the spacer below cannot drift from it. */
export const CAP_DONUT_RADIUS = 9;

/** Keeps a donut-less cap value on the same left edge as the rows that have one. */
function VaultV2CapDonutSpacer() {
  const $ = _c(1);
  const size = CAP_DONUT_RADIUS * 2;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="shrink-0" style={{
      width: size,
      height: size
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default VaultV2CapDonutSpacer;